import React from "react";
import { useCookieConsent } from "../context/ConsentContext";

/**
 * Eine Komponente, die den aktuellen Cookie-Zustimmungsstatus anzeigt
 * und einen Button zum Ändern der Einstellungen bereitstellt.
 */
const ConsentStatusViewer = () => {
  const { consent, consentCategories, openSettings } = useCookieConsent();

  const containerStyle = {
    padding: "15px",
    marginTop: "20px",
    marginBottom: "30px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
  };

  const listStyle = {
    listStyleType: "none",
    paddingLeft: 0,
  };

  const listItemStyle = {
    marginBottom: "5px",
  };

  return (
    <div style={containerStyle}>
      <h4>Aktueller Cookie-Status</h4>
      {!consent ? (
        <p>Es wurde noch keine Auswahl getroffen.</p>
      ) : (
        <ul style={listStyle}>
          {consentCategories
            .filter((cat) => !cat.isMandatory) // Zeige nur die optionalen Kategorien
            .map((cat) => (
              <li key={cat.id} style={listItemStyle}>
                <strong>{cat.name}:</strong>{" "}
                <span
                  style={{
                    color: consent[cat.id] ? "green" : "red",
                    fontWeight: "bold",
                  }}
                >
                  {consent[cat.id] ? "Zugelassen" : "Abgelehnt"}
                </span>
              </li>
            ))}
        </ul>
      )}
      <div className="button button-red">
        <button onClick={openSettings}>Einstellungen ändern</button>
      </div>
    </div>
  );
};

export default ConsentStatusViewer;
